import React, { Fragment, useState, useEffect } from "react";
import { Col, Card, CardHeader, CardBody, Form, FormGroup, Label, Row } from "reactstrap";
import { Btn, Breadcrumbs, H3 } from "../../../AbstractElements";
import { useForm, Controller } from "react-hook-form";
import { useNavigate, Link } from "react-router-dom";
import "react-phone-input-2/lib/style.css";
import { toast } from "react-toastify";
import Typeahead from "../../../CommonElements/TypeAhead";
import { NewBinAccount, Save, BillAccountNo, ServiceAddress, DriversID, AccountStatus, Area, Longitude, Latitude, BinAccount } from "../../../Constant";
import { addStb, addStbRole, getArea, getAreaRole, getDriver, getDriverRole } from "../../../CommonUrl";
import { useSelector } from "react-redux";
import { getClientUrlDataToken, postClientUrlWithToken } from "../../../Utils/restUtils";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import Transparentspinner from "../../Common/Loader/Transparentspinner";
import CustomerDropdown from "../../Common/CustomerField/CustomerDropdown";
import TypeaheadAdd from "../../../CommonElements/TypeAheadAdd";
import Popup from "../../Common/Popup/popup";
import AreaAdd from "./AreaAdd";

const schema = yup.object().shape({
  customer: yup.mixed().required().label('Customer'),
  binAccnt: yup.string().required().label('Bin Account number'),
  driver: yup.mixed().required().label('Driver'),
  account: yup.mixed().required().label('Account'),
  areaName: yup.mixed().required().label('Area'),
  service: yup.string().required().label('Service Address'),
})

const StbForm = () => {
  const { register, handleSubmit, control, formState: { errors } } = useForm({
    resolver: yupResolver(schema),
  });

  const authState = useSelector((state) => state.auth);
  const [loading, setLoading] = useState(false);
  const [modal, setModal] = useState(false);
  const [area, setArea] = useState([]);
  const [users, setUsers] = useState([]);
  const [areaOption, setAreaOption] = useState([]);
  const [userOption, setUserOption] = useState([]);
  const changepwdtitile = <span className='billerqColor bolder '><h3>Add Area</h3></span>;

  const options = [
    { value: "active", label: "Active" },
    { value: "suspended", label: "Suspend" },
    { value: "disconnected", label: "Disconnect" },
  ];

  const navigate = useNavigate();

  useEffect(() => {
    areaData();
    userData();
  }, []);

  useEffect(() => {
    setAreaOption(
      area.map((item) => ({
        value: item.id,
        label: item.name,
      }))
    );
  }, [area]);

  useEffect(() => {
    setUserOption(
      users.map((item) => ({
        value: item.id,
        label: item.user_name,
      }))
    );
  }, [users]);

  const handleApiError = (status) => {
    if (status >= 400 && status <= 405) {
      navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
    } else if (status >= 500 && status <= 505) {
      navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
    } else {
      navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
    }
  };

  const handleModal = () => {
    setModal(!modal);
  };

  const areaData = async () => {
    const data = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ? getArea : getAreaRole);
    if (data.status === true) {
      setArea(data.data);
    } else {
      handleApiError(data.status);
    }
  };

  const userData = async () => {
    const data = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ? getDriver : getDriverRole);
    if (data.status === true) {
      setUsers(data.data);
    } else {
      handleApiError(data.status);
    }
  };

  const onSubmit = async (data) => {
    setLoading(true);
    const postRequest = {
      area_id: data.areaName.value,
      service_address: data.service,
      customer_id: data.customer.value,
      driver_id: data.driver.value,
      bin_account: data.binAccnt,
      latitude: data.latitude,
      longitude: data.longitude,
      status: data.account?.value ?? '',
    };
    const addStbResponse = await postClientUrlWithToken(
      authState.apiUrl,
      authState.userRole === 1 ? addStb : addStbRole,
      postRequest
    );
    if (addStbResponse.status === 200) {
      if (addStbResponse.data.status === true) {
        navigate(`${process.env.PUBLIC_URL}/customers/bin`);
        toast.success(addStbResponse.data.message);
      } else {
        toast.error(addStbResponse.data.message);
      }
    } else if (addStbResponse.status >= 400 && addStbResponse.status <= 405) {
      navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
    } else if (addStbResponse.status >= 500 && addStbResponse.status <= 505) {
      navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
    } else {
      navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
    }
    setLoading(false);
  };
  return (
    <Fragment>
      {loading && <Transparentspinner />}
      <Breadcrumbs mainTitle={BinAccount} parent="Customers" title={BinAccount} />
      <Card>
        <CardHeader className="pb-0">
          <H3>{NewBinAccount}</H3>
        </CardHeader>
        <CardBody>
          <Form className="needs-validation" noValidate onSubmit={handleSubmit(onSubmit)}>
            <Row className="g-3">
              <CustomerDropdown control={control} errors={errors} />
              <Col md="6">
                <Label className="form-label" for="binAccnt">{BillAccountNo}<span className="requireStar">*</span></Label>
                <input className="form-control" id="binAccnt" type="text" {...register("binAccnt", { required: true })} />
                <p className="text-danger">{errors.binAccnt?.message}</p>
              </Col>
            </Row>
            <Row className="g-3 pt-3">
              <Col md="6">
                <Label className="form-label" >
                  {Area} <span className="requireStar">*</span>
                </Label>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <Controller
                    name="areaName"
                    control={control}
                    render={({ field }) => (
                      <TypeaheadAdd
                        options={areaOption}
                        onChange={(value) => {
                          field.onChange(value);
                        }}
                        value={field.value}
                      />
                    )}
                  />
                  <div className="plusDesign" onClick={handleModal}>+</div>
                </div>
                <p className="text-danger">{errors.areaName?.message}</p>
              </Col>

              <Col md="6">
                <Label className="form-label" >
                  {DriversID} <span className="requireStar">*</span>
                </Label>
                <Controller
                  name="driver"
                  control={control}
                  render={({ field }) => (
                    <Typeahead
                      options={userOption}
                      onChange={(value) => {
                        field.onChange(value);
                      }}
                      value={field.value}
                    />
                  )}
                />
                <p className="text-danger">{errors.driver?.message}</p>
              </Col>
            </Row>
            <Row className="g-3 pt-3">
              <Col md="6">
                <Label className="form-label" >{AccountStatus} <span className="requireStar">*</span></Label>
                <Controller
                  name="account"
                  control={control}
                  render={({ field }) => (
                    <Typeahead
                      options={options}
                      onChange={(value) => {
                        field.onChange(value);
                      }}
                      value={field.value}
                    />
                  )}
                />
                <p className="text-danger">{errors.account?.message}</p>
              </Col>
              <Col md="6">
                <Label className="form-label" for="service">{ServiceAddress} <span className="requireStar">*</span></Label>
                <textarea className="form-control" id="service" type="text" {...register("service", { required: true })} />
                <p className="text-danger">{errors.service?.message}</p>
              </Col>
            </Row>
            <h3 className="mt-3">Bin Location</h3>
            <Row className="g-3 pt-3">
              <Col md="6">
                <Label className="form-label" for="latitude">{Latitude}</Label>
                <input className="form-control" id="latitude" type="text" {...register("latitude")} />
                {/* <p className="text-danger">{errors.serialNo?.message}</p> */}
              </Col>
              <Col md="6">
                <Label className="form-label" for="longitude">{Longitude}</Label>
                <input className="form-control" id="longitude" type="text" {...register("longitude")} />
                {/* <p className="text-danger">{errors.serialNo?.message}</p> */}
              </Col>
            </Row>

            <FormGroup></FormGroup>
            <div className="d-flex justify-content-center mt-3 gap-2">
              <Btn attrBtn={{ color: "primary" }} type="submit">
                {Save}
              </Btn>
              <Link to="/customers/bin" className="btn btn-light" type="button">
                Cancel
              </Link>
            </div>
          </Form>
        </CardBody>
      </Card>
      <Popup isOpen={modal} title={changepwdtitile} toggler={handleModal}>
        <AreaAdd setModal={setModal} handleVendorAdded={areaData} />
      </Popup>
    </Fragment>
  );
};
export default StbForm;
